// AI Generated file
import { Component, Input } from '@angular/core';

@Component({
    selector: 'user-date',
    template: `
        <span class="text-nowrap" *ngIf="date && !twoLines">{{ date | userDate:'ll LT' }}</span>
        <span class="text-nowrap d-inline-block" *ngIf="date && twoLines">{{ date | userDate:'ll' }}</span>
        <span class="text-nowrap" *ngIf="date && twoLines">{{ date | userDate:'LT' }}</span>
    `,
    standalone: false,
})
export class UserDateComponent {
    @Input() date: any;
    @Input() twoLines?: boolean = false;
}
